import React from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { MapBlockedContainer, MapConsentRequestButton, StyledEyeCrossedIcon, StyledApprovalText, } from '../styles/LocationFilter.styles';
import { useDesktopOrMobileView } from '../../../hooks';
import CookieConsentRequest from './CookieConsentRequest';
import { FilterContext } from '../FilterContext';
import { ThemeProvider } from '@oneaudi/unified-web-common';
export const MapBlockedWrapper = ({ consent, mobileNavBarState, mapConsentButtonText, openConsentOverlay, setIsTwoClickOverlayOpened, }) => {
    const context = React.useContext(FilterContext);
    const { setWholeMarketDealersFetch } = context;
    const isDesktop = useDesktopOrMobileView('1024px') === 'desktop';
    const mapConsentRequestText = useI18n({
        id: `nemo.sc.filter.locationfilter.cookieConsentRequestMap.Text`,
        defaultMessage: 'Content requires your approval',
    });
    return (React.createElement(React.Fragment, null, !consent &&
        ((!isDesktop && mobileNavBarState === 'nav-bar-location-search-mobile--map-view') ||
            isDesktop) && (React.createElement(React.Fragment, null,
        isDesktop && (React.createElement(CookieConsentRequest, { mapConsentButtonText: mapConsentButtonText, openConsentOverlay: openConsentOverlay, setIsTwoClickOverlayOpened: setIsTwoClickOverlayOpened })),
        React.createElement(MapBlockedContainer, null,
            React.createElement(StyledEyeCrossedIcon, { size: "l", name: "eye-crossed" }),
            React.createElement(StyledApprovalText, null, mapConsentRequestText),
            !isDesktop && (React.createElement(ThemeProvider, { theme: { name: 'dark' } },
                React.createElement(MapConsentRequestButton, { variant: "primary", size: "sm", onClick: () => {
                        setWholeMarketDealersFetch(true);
                        openConsentOverlay();
                        setIsTwoClickOverlayOpened(true);
                    } }, mapConsentButtonText))))))));
};
export default MapBlockedWrapper;
